import { hbs } from 'ember-cli-htmlbars';
export default hbs("{{format-amount-or-duration @record.actualValue @record.actualUnit}}")